import { store } from '../../stateManager'
import { Scope } from './interface'

export default function service(scope: Scope) {
    const state = store.getState()
    const appType = state.apps.selectedApp.type
    return `
        declare var crypto: any;
        declare var xmlparser: any;
        declare var soap: any;
        declare var he: any;
        declare var session: any;
        declare var console: any;
        declare var logger: any;
        declare var axios: any;
        declare var moment: any;
        declare var core: any;
        declare var Buffer: any;
        declare var FormData: any;
        declare var console: any;
        declare var https: any;

        interface IFile {
            filename: string;
            content : string;
            mimetype: string
        };

        interface IValueInfo{
            filename: string;
            mimetype: string;
        }

        interface IValue{
            type: string;
            value: string;
            valueInfo: IValueInfo;
        };

        interface TaskService {
            complete: (task: any, variables: Variables) => void
        };

        declare class FileVariable {
            constructor(options: IFile)
        };
        declare class Variables {
            set(name: string, value: any): void
            setTyped(fileText: string, value: IValue): void
        };
        declare var variables: {
            get: (variableName: string) => any;
            getTyped: (variableName: string) => any;
            getAll: () => any[];
            getAllTyped: () => any[];
        };
        ${scope === 'service' && (appType === "a8solo" || appType === "a8chat") ? 'declare function deleteVariable(variableName: string, softDelete?: boolean): void' : ''}
        ${scope === 'service' && (appType === "a8solo" || appType === "a8chat") ? 'declare function deleteVariables(variableName: string[], softDelete?: boolean): void' : ''}
    `
}
